var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('base-image-view',{ref:"img-view",attrs:{"initial-index":_vm.initIndex,"onClose":()=>_vm.show = false,"url-list":_vm.list,"zIndex":2200}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }